module.exports = __webpack_public_path__ + "static/media/logo_error.631accb2.svg";